<template>
    <div class="list">
        <div class="list_bg" v-for="item in list.slice((page-1)*per_page, page*per_page)" :key="item.id">
            <router-link :to="{ name: router_name, params: { id: item.id }}" class="newsbox d-flex">
            <div class="list_img col-3" ><img :src="item.image_url" :alt="123"></div>
            <div class="list_date col-1">{{item.create_at.substr(0,10)}}</div>
            <div class="list_text col-8">
                <div class="listtitle clamp">{{item.title}}</div>
                <div class="rwd_date">{{item.create_at.substr(0,10)}}</div>
                <div class="content clamp">{{item.content}}</div>
                <div class="more">more ⇀</div>
            </div>
            </router-link >
        </div>
        <pagination v-model="page" 
        :page-range="1"
        :records="list.length" 
        :per-page="per_page" 
        :options="page_options"
        @paginate="gotop">
        </pagination>
    </div>
</template>
<script>
// import IndexTitle from '@/components/index/IndexTitle'
import Pagination from 'vue-pagination-2'
// import {Pagination,PaginationEvent} from 'vue-pagination-2'
export default {
    components: {
        // 'indexTitle': IndexTitle,
        'pagination': Pagination,
    },
    props:  [
        "list",
        "router_name",
        ],
    data () {
    return {
      page: 1,
      per_page: 10,
      page_options: {
          chunk :5,
          chunksNavigation :'scroll', 
        texts: {
          count: '{from}-{to}/{count} | {from}-{to}/{count} | ',
        //   count: ' {from} | {from}  | {from}  ',
        }
      },
    }
  },
  methods: {
      gotop: function() {
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
        },
      
  }
}
</script>
<style>
.list{
    margin: 0 auto;
}
.list .list_bg:nth-child(2n){
     background: #f5f5f5
}
.list .newsbox{
    max-width: 1200px;
    text-decoration: none;
    color:black; 
    padding: 20px 0;
    margin: 0 auto;
    line-height: 30px;
}
.list .newsbox:hover .listtitle{
    color:#00a0e9; 
}
.list .list_img{
    width: 200px;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
.list .list_img img{
    width: 100%;
    height: auto;
}
.list .list_date{
    font-size: 13px;
    text-align: center;
    padding: 0;
}
.list .clamp{
    /* overflow:hidden; 
    text-overflow:ellipsis;
    display:-webkit-box; 
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;  */
    /* line-height: 2;
    max-height: 4;
    white-space: nowrap; */

    /* position: relative;
    height: 55px;
    text-overflow: ellipsis;
    white-space: normal;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical; */
}

 /* .list .clamp::after {          
     background: linear-gradient(to right, rgba(255, 255, 255, 0), #FFFFFF 70%) repeat scroll 0 0 rgba(0, 0, 0, 0);
          bottom: 0;
          content: "...";
          padding: 0 5px 1px 30px;
          position: absolute;
          right: 0;
 } */
.list .listtitle{
    font-size: 19px;
    font-weight: 700;
}
.list .content{
    margin: 20px 0;
    font-size: 15px;
     color: #808080;
     line-height: 25px;
}
.list .rwd_date{
    font-size: 13px;
    margin-top: 20px;
}
.list .more{
    font-size: 19px;
    color:#00a0e9; 
}
@media (min-width: 769px){
    .list .rwd_date{
        display: none;
    }
}
@media (max-width: 768px){
    .list .list_date{
        display: none;
    }
    .list .content{
        display: none;

    }
    .list .newsbox{
        flex-direction: column;
    }
    .list .list_img{
        width: 100%;
        max-width: 100%;
        height: auto;
        
    }
    .list .list_text{
        width: 100%;
        max-width: 100%;
        height: auto;
        margin-top: 20px;
    }
    .list .more{
        margin-top: 12px;
    }
}

.list .page-link {
    color: black;
    font-weight: 700;
}

.list .VuePagination ul{
    list-style-type: none ;
    margin: 50px 0 20px;
    padding: 0;
    display: flex;
    justify-content: center;
}
.list .VuePagination ul .page-item{
    width: 50px;
    height: 50px;
    line-height: 44px;
    margin: 0px 3px;
    border: 2px solid #cccccc;
    text-align: center;
}
.list .VuePagination ul .page-item:hover{
    border: 2px solid #00a0e9;
}
.list .VuePagination ul .page-item.active{
    background: #00a0e9;
    border: 2px solid #00a0e9;
}
.list .VuePagination ul .page-item.active a{
    color: white;
}
.list .VuePagination ul .page-item a{
    display: block;
    width: 100%;
    height: 100%;
    text-decoration: none;
    color: #808080;
    font-size: 17px;
}
.list  .VuePagination__count {
    display: none;
}
</style>


